import React, { useContext, useEffect, useState } from 'react'

import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined'
import InstagramIcon from '@mui/icons-material/Instagram'
import LinkedInIcon from '@mui/icons-material/LinkedIn'
import CallIcon from '@mui/icons-material/Call'
import { useNavigate } from 'react-router-dom'
import { isBefore, isAfter } from 'date-fns'

import favicon from '../../assets/images/favicon.png'
import { ModalInformation } from '../ModalInformation'
import { useGetSettings } from 'src/services/backend'
import { Button } from '../Button'
import * as S from './styles'
import DataContext from 'src/contexts/DataContext'

import { useLocationPath } from '../../hooks/useLocationPath'
import { navigateToInstitute } from 'src/utils'
import { TCourses } from 'src/contexts/tools'
import { useCourseInfoHook } from 'src/hooks/useCourseInfoHook'

interface INavbarProps {
  course?: TCourses
}

const Navbar = (props: INavbarProps) => {
  const navigate = useNavigate()

  const [courseLogo, setCourseLogo] = useState<string>('')

  const { registration, setRegistration } = useContext(DataContext)

  const currentCourseInfo = useCourseInfoHook({
    course: registration.course! || props.course,
  })

  const [open, setOpen] = React.useState(false)

  const [getSettings, settings] = useGetSettings()

  const path = useLocationPath()

  const handleCopyClick = (textCopied: string) => {
    navigator.clipboard.writeText(textCopied)
  }

  const handleModalInformation = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  useEffect(() => {
    getSettings()
  }, [])

  useEffect(() => {
    currentCourseInfo && setCourseLogo(currentCourseInfo.logo_url)
  }, [currentCourseInfo])

  useEffect(() => {
    if (settings?.data)
      if (settings?.data[0]?.maintenance) {
        navigate('/manutencao')
      } else if (path.includes('manutencao')) {
        navigateToInstitute()
      }
  }, [settings?.data])

  useEffect(() => {
    if (currentCourseInfo) {
      const today = new Date()
      const end_date = new Date(currentCourseInfo?.end_process)
      const start_date = new Date(currentCourseInfo?.start_process)
      if (isBefore(today, start_date)) {
        setRegistration((prevState: any) => ({
          ...prevState,
          course: currentCourseInfo?.name,
        }))
        navigate('/inscricoes-nao-inciadas')
      } else if (isAfter(today, end_date)) {
        setRegistration((prevState: any) => ({
          ...prevState,
          course: currentCourseInfo?.name,
        }))
        navigate('/inscricoes-fechadas')
      }
    }
  }, [currentCourseInfo])

  return (
    <S.Wrapper>
      <S.PerfilContent>
        {props.course ? (
          <S.Logo>
            <img src={courseLogo} alt="Logo Instituto J&F" />
          </S.Logo>
        ) : (
          <S.Favicon>
            <img src={favicon} alt="Logo Instituto J&F" />
          </S.Favicon>
        )}
        <S.SocialIconsContainer>
          <S.BackgroundIcon
            href="https://www.instagram.com/institutojef/"
            target="_blank"
          >
            <InstagramIcon />
          </S.BackgroundIcon>
          <S.BackgroundIcon
            href="https://www.facebook.com/institutojef"
            target="_blank"
          >
            <FacebookOutlinedIcon />
          </S.BackgroundIcon>
          <S.BackgroundIcon
            href="https://www.linkedin.com/company/institutojef"
            target="_blank"
          >
            <LinkedInIcon />
          </S.BackgroundIcon>
          <S.ButtonContact
            variant={'outlined'}
            startIcon={<CallIcon />}
            onClick={() => handleModalInformation()}
          >
            <S.ButtonLabel>Contato</S.ButtonLabel>
          </S.ButtonContact>
        </S.SocialIconsContainer>
      </S.PerfilContent>

      <ModalInformation
        title="Contato"
        isOpen={open}
        onCloseModal={handleClose}
      >
        <S.ModalBox>
          <S.ContainerContent>
            <S.BoxContact>
              <S.WhatsApp />
              <S.DescriptionModal>(11) 99732-4047</S.DescriptionModal>
            </S.BoxContact>
            <S.CopyButton onClick={() => handleCopyClick('(11) 99732-4047')}>
              <S.CopyDescription>copiar</S.CopyDescription>
              <S.Copy />
            </S.CopyButton>
          </S.ContainerContent>

          <S.ContainerContent>
            <S.BoxContact>
              <S.Email />
              <S.DescriptionModal>admissao@germinare.org.br</S.DescriptionModal>
            </S.BoxContact>
            <S.CopyButton
              onClick={() => handleCopyClick('admissao@germinare.org.br')}
            >
              <S.CopyDescription>copiar</S.CopyDescription>
              <S.Copy />
            </S.CopyButton>
          </S.ContainerContent>

          <S.ContainerContent>
            <S.BoxContact>
              <S.Phone />
              <S.DescriptionModal>(11) 3623-6034</S.DescriptionModal>
            </S.BoxContact>
            <S.CopyButton onClick={() => handleCopyClick('(11) 3623-6034')}>
              <S.CopyDescription>copiar</S.CopyDescription>
              <S.Copy />
            </S.CopyButton>
          </S.ContainerContent>

          <S.ModalBoxButtons>
            <Button variant={'outlined'} onClick={() => setOpen(false)}>
              Fechar
            </Button>
          </S.ModalBoxButtons>
        </S.ModalBox>
      </ModalInformation>
    </S.Wrapper>
  )
}

export { Navbar }
